export class DeviceInfo {
    uuid: string;
    pushToken: string;
    manufacturer;
    model: string;
    platform: string;
    osVersion: string;
    lastLogin: Date;
}
